/* eslint-disable
    no-return-assign,
    no-useless-escape
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';
import React from 'react';

import InsertPartTemplate from 'molbio/parts/InsertPartTemplate';
import InsertPartSequenceTemplate from 'molbio/parts/InsertPartSequenceTemplate';
import notifications from 'notifications';
import * as popup from 'Popup';
import SequenceSearchView from 'components/SequenceSearchView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

class InsertPartModalView extends popup.Popup {
  static initClass() {
    this.prototype.template = InsertPartTemplate;
    this.prototype.sequenceTemplate = InsertPartSequenceTemplate;
    this.prototype.title = 'Choose Part';
  }

  form() {
    renderToDOM(<InsertPartTemplate nucleotideType={this.sequence.nucleotideType()} />, this.$body[0]);
    this.choice({
      type: 'submit',
      text: 'Choose Part',
    });
    this.choice({
      type: 'cancel',
      text: 'Cancel',
    });

    this.searchView.setElement(this.$body.find('.search'));
    return this.searchView.render();
  }

  _getPath(sequence) {
    const regex = /\/([^\/]+)\//; // "/MATCHES_BETWEEN_FIRST_SLASHES/blah/blah"
    const match = regex.exec(sequence.get('editURL'));
    const folder = sequence.folder().name;
    if (match != null) {
      return `${match[1]}/${folder}`;
    } else {
      return folder;
    }
  }

  initialize({sequence, oldPart}) {
    this.sequence = sequence;
    this.oldPart = oldPart;
    this.selectSequence = this.selectSequence.bind(this);
    return (this.searchView = new SequenceSearchView({
      selectSequence: this.selectSequence,
      nucleotideType: this.sequence.nucleotideType(),
      excludeModified: true,
    }));
  }

  selectSequence(sequence) {
    this.$('.selected-sequence')
      .empty()
      .data('sequence', sequence)
      .append(this.sequenceTemplate({sequence, getPath: this._getPath}));

    if (sequence.get('circular')) {
      this.$('.warning').html(
        '<b>Note:</b> The selected sequence is <b>circular</b>, but will be inserted as a <b>linear</b> sequence.'
      );
    } else {
      this.$('.warning').text('');
    }
    this.check();
  }

  focus() {
    return this.searchView.focus();
  }

  validate() {
    const sequence = $('.selected-sequence').data('sequence');
    const reverseComplemented = this.$('.reverse-complement').is(':checked');
    if (sequence != null) {
      return [sequence, reverseComplemented];
    } else {
      return false;
    }
  }

  submit() {
    let start;
    const [sequence, reverseComplemented] = Array.from(this.validate());
    let options = {reverse: false, complement: false};
    if (reverseComplemented) {
      options = {reverse: true, complement: true};
    }

    const selection = this.sequence.selection();
    if (this.oldPart != null || !selection.isEmpty()) {
      start = this.oldPart ? this.oldPart.start() : selection.start();
      const end = this.oldPart ? this.oldPart.end() : selection.end();
      this.sequence.replaceWithPart(start, end, sequence.id, options).fail(notifications.notifyError);
    } else {
      this.sequence.insertPart(selection.start(), sequence, options).fail(notifications.notifyError);
    }
    this.close();
  }
}

InsertPartModalView.initClass();

export default InsertPartModalView;
